import ReceivedLogs from '../../components/pages/mypages/ReceivedLogs.vue'
export default {
  components: { ReceivedLogs }
}
